module.exports = __webpack_public_path__ + "flyer_background_pumpkin_two_046-fd486c3a9e14e62a30817b9604a7fcc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_pumpkin_two_046.jpg
// module id = 1680
// module chunks = 1